import { uuid7 } from "Common/uuid7";
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import findIndex from "lodash/findIndex";
import forEach from "lodash/forEach";
import map from "lodash/map";
import GroupEdgesSource from "../../types/groupEdgesSource";
import createEdge from "./createEdge";
export default (graphComponentRef, edgeSources) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return;
    const processedEdgeIds = new Set();
    const nodeMap = {};
    const groupMap = {};
    graphComponentRef.current.graph.nodes.forEach(item => {
        if (!graphComponentRef.current)
            return;
        if (graphComponentRef.current.graph.isGroupNode(item)) {
            groupMap[item.tag.GroupId] = item;
            if (item.tag.Nodes)
                item.tag.Nodes.forEach(node => {
                    nodeMap[node.NodeId] = item;
                });
        }
        else {
            nodeMap[item.tag.NodeId] = item;
        }
    });
    const getINodes = (edgeSource) => {
        const fromINode = nodeMap[edgeSource.From] ||
            (edgeSource.FromGroup ? groupMap[edgeSource.FromGroup] : undefined);
        const toINode = nodeMap[edgeSource.To] || (edgeSource.ToGroup ? groupMap[edgeSource.ToGroup] : undefined);
        return { source: edgeSource, fromINode, toINode };
    };
    const edgeSourcesMap = map(edgeSources, getINodes);
    forEach(edgeSourcesMap, e => {
        var _a;
        if (!graphComponentRef.current || processedEdgeIds.has(e.source.EdgeId)) {
            return;
        }
        processedEdgeIds.add(e.source.EdgeId);
        if (!e.fromINode || !e.toINode) {
            console.warn(`Nodes were not founded for edge with EdgeId="${e.source.EdgeId}", From="${e.source.From}" and To="${e.source.To}", FromGroup="${e.source.FromGroup}" and ToGroup="${e.source.ToGroup}"`);
            return;
        }
        const prevEdge = graphComponentRef.current.graph.edges.find(item => item.sourceNode === e.fromINode && item.targetNode === e.toINode);
        const itemsWithSameFromTo = filter(edgeSourcesMap, item => Boolean(item.fromINode === e.fromINode && item.toINode === e.toINode));
        if (!prevEdge) {
            forEach(itemsWithSameFromTo, item => {
                processedEdgeIds.add(item.source.EdgeId);
            });
            createEdge(graphComponentRef, map(itemsWithSameFromTo, "source"), e.fromINode, e.toINode);
        }
        else if (!prevEdge.tag ||
            (prevEdge.tag.From === e.source.From &&
                prevEdge.tag.To === e.source.To)) {
            prevEdge.tag = e.source;
        }
        else if ((_a = prevEdge.tag) === null || _a === void 0 ? void 0 : _a.Edges) {
            const resultTag = cloneDeep(prevEdge.tag);
            forEach(itemsWithSameFromTo, item => {
                processedEdgeIds.add(item.source.EdgeId);
                const edgeTagIndex = findIndex(resultTag.Edges, ["EdgeId", item.source.EdgeId]);
                const resultEdgeSource = { ...item.source, GroupId: resultTag.GroupId };
                if (edgeTagIndex !== -1)
                    resultTag.Edges[edgeTagIndex] = resultEdgeSource;
                else
                    resultTag.Edges = [...resultTag.Edges, resultEdgeSource];
            });
            prevEdge.tag = resultTag;
        }
        else {
            forEach(itemsWithSameFromTo, item => {
                processedEdgeIds.add(item.source.EdgeId);
            });
            prevEdge.tag = new GroupEdgesSource(uuid7(), [
                prevEdge.tag,
                ...map(itemsWithSameFromTo, "source")
            ]);
        }
    });
};
